import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const { data, error } = await supabase.auth.getSession();
        if (error) throw error;

        if (data.session) {
          const user = data.session.user;
          const name = user.user_metadata?.full_name || user.email?.split('@')[0] || 'Bạn';
          localStorage.setItem('bahnar_user', JSON.stringify({
            name,
            email: user.email,
            type: 'full',
          }));
          setStatus('success');
          setTimeout(() => navigate('/games'), 1500);
        } else {
          setStatus('error');
          setTimeout(() => navigate('/login'), 2000);
        }
      } catch {
        setStatus('error');
        setTimeout(() => navigate('/login'), 2000);
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-primary-cream flex items-center justify-center">
      <div className="text-center">
        {status === 'loading' && (
          <>
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
              <div className="w-12 h-12 border-4 border-primary-orange border-t-transparent rounded-full animate-spin"></div>
            </div>
            <p className="text-primary-brown-dark font-semibold text-lg">Đang xác thực...</p>
            <p className="text-primary-brown-light text-sm mt-1">Vui lòng chờ trong giây lát</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="w-16 h-16 flex items-center justify-center bg-green-100 rounded-full mx-auto mb-4">
              <i className="ri-check-line text-3xl text-green-500"></i>
            </div>
            <p className="text-primary-brown-dark font-bold text-xl">Đăng nhập thành công!</p>
            <p className="text-primary-brown-light text-sm mt-1">Đang chuyển đến trang trò chơi...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="w-16 h-16 flex items-center justify-center bg-red-100 rounded-full mx-auto mb-4">
              <i className="ri-close-line text-3xl text-red-500"></i>
            </div>
            <p className="text-primary-brown-dark font-bold text-xl">Có lỗi xảy ra</p>
            <p className="text-primary-brown-light text-sm mt-1">Đang chuyển về trang đăng nhập...</p>
          </>
        )}
      </div>
    </div>
  );
}
